import { useMutation } from '@tanstack/react-query';

import { initializeChat } from '../api/chat.api';

import type { InitializeChatResponse } from '../types/chat.types';

export function useInitializeChat() {
  return useMutation<InitializeChatResponse>({
    mutationFn: initializeChat
  });
}
